/* Auto-submit any form control marked [data-auto-submit] (e.g. the sort menu). */
document.addEventListener("change", (e) => {
  const el = e.target.closest("[data-auto-submit]");
  if (el && el.form) el.form.submit();
});
